// Basic
import PropTypes from 'prop-types';
// Store & actions
import actionsOrganizations from '@/app/modules/organizations/api/actionsOrganizations';
// Components
import LegalInfosPanel from '@/app/modules/organizations/components/details/LegalInfosPanel';
import Entity from '@/common-utils/components/renders/entity/Entity';
import Spinner from '@/common-utils/components/renders/spinner/Spinner';
import { Modal, ModalBody, ModalContent } from '@/common-utils/components/ui/modal';
import Info from '@/common-utils/components/renders/info/Info';
import HeaderTitle from '@/common-utils/components/renders/modal/components/headers/HeaderTitle/HeaderTitle';
// Common
import logoSocieteDotCom from 'url:../../../../../../../resource/images/logoSocieteDotCom.png';
import ICONS from '@/common-utils/enums/icons';
// Lang
import { nsOrganization } from '@/app/i18n/namespaces';

/**
 * @param root0
 * @param root0.registrationNumber
 * @param root0.isOpen
 * @param root0.setIsOpen
 * @returns {JSX} ModalLegalInfos
 */
function ModalLegalInfos({ registrationNumber, isOpen, setIsOpen }) {
    // API Calls
    const { data, isLoading } = actionsOrganizations.checkRegistrationNumber(registrationNumber, true);

    // Constants
    const moreInfoUrl = `https://www.societe.com/cgi-bin/search?champs=${registrationNumber.substr(0, 9)}`;

    return <Modal open={isOpen} onOpenChange={setIsOpen}>
        <ModalContent className='max-w-2xl'>
            <HeaderTitle title='details.legal_infos.title' namespace={nsOrganization} />
            <ModalBody>
                {
                    isLoading &&
                    <Spinner className={'mt-4'} />
                }
                {
                    !isLoading && data &&
                    <LegalInfosPanel legalInfos={data} showTitle={false} />
                }
                {
                    !isLoading && !data &&
                    <div className='p-2'>
                        <Info
                            entity='keys.no_legal_info'
                            namespace={nsOrganization}
                            icon={ICONS.INFO}
                            className='justify-center'
                            variant='info'
                        />
                        <div className='flex gap-2 justify-center my-4'>
                            <Entity entity='keys.more_legal_info' namespace={nsOrganization} />
                            <a href={moreInfoUrl} target='_blank'>
                                <img alt='' className='with-text' src={logoSocieteDotCom} />
                            </a>
                        </div>
                    </div>
                }
            </ModalBody>
        </ModalContent>
    </Modal>;

}

ModalLegalInfos.propTypes = {
    registrationNumber: PropTypes.string.isRequired,
    isOpen: PropTypes.bool.isRequired,
    setIsOpen: PropTypes.func.isRequired
};

export default ModalLegalInfos;